/**
 * Single source of truth for the WhatsApp contact. Change this one value to
 * point every "Chat on WhatsApp" CTA at a new number.
 */
export const WHATSAPP_NUMBER = 'wa.me/2349041034769';

/** Click-to-chat link. Only the digits of the number are used, so any format above works. */
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER.replace(/\D/g, '')}`;
